

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
// import PathwayIcon from "./PathwayIcon";
import Stack from "@mui/material/Stack";
import CommitCheckbox from "./CommitCheckbox";
import CommitData from "../../models/interactions/commit/CommitData";
import IntervalSet from "../../models/communications/IntervalSet";
import Interaction from "../../models/interactions/Interaction";
import CommunicationSet from "../../models/communications/CommunicationSet";
import Interval from "../../models/communications/Interval";
import LockIcon from '@mui/icons-material/Lock';
import { convertToNormalWords } from "../../models/BaseTable";

interface CommitSectionProps {
    commitData: CommitData;
    type: keyof CommitData;
    handleChange: any;
}

type CommitDataType = keyof CommitData;

const CommitSection = (props: CommitSectionProps) => {
    const data: any = props.commitData[props.type] || []; // Fallback to an empty array if undefined

    return (
        <Box
            sx={{
                width: "95%",
                flexGrow: 1,
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: "15px",
                border: "1pt solid #ebeded",
                borderRadius: "10px 10px",
                paddingBottom: "20px",
            }}
        >
            <h3 style={{ padding: "10px" }}>{convertToNormalWords(props.type)}</h3>
            <Grid container spacing={1}>
                <Grid item xs={2} style={{ textAlign: "right" }}>
                    <Stack>
                        <h2>ID |</h2>
                        {data.map((item: Interaction | IntervalSet | CommunicationSet | Interval) => {
                            return <div key={item.id}>{item.id}</div>;
                        })}
                    </Stack>
                </Grid>
                <Grid item xs={4}>
                    <Stack>
                        <h2>Title</h2>
                        {data.length > 0 &&
                            data.map((item: Interaction | IntervalSet | CommunicationSet | Interval) => {
                                return (
                                    <div key={item.id} style={{ textAlign: "left" }}>
                                        {item?.name || item?.title} 
                                        {item?.shared && 
                                            <span style={{color:"red", fontWeight:"bold"}}>&nbsp;
                                            (SHARED <LockIcon style={{fontSize:"12pt"}}/>)</span>
                                        }
                                    </div>
                                );
                            })}
                        {data.length < 1 && (
                            <div style={{ color: "green", padding: "10px" }}>
                                Everything is up to date!
                            </div>
                        )}
                    </Stack>
                </Grid>
                <Grid item xs={2}>
                    <Stack>
                        <h2>Status</h2>

                        {data.map((item: Interaction | IntervalSet | CommunicationSet | Interval) => {
                            return (
                                <div key={item.id} style={{ color: "red" }}>
                                    Modified
                                </div>
                            );
                        })}
                    </Stack>
                </Grid>
                <Grid item xs={4}>
                    <Stack>
                        <h2 style={{ textAlign: "center" }}>Commit</h2>

                        {data.map((item: Interaction | IntervalSet | CommunicationSet | Interval) => {
                            return (
                                <CommitCheckbox
                                    key={item.id}
                                    communication_set={props.type === 'communication_sets' as CommitDataType ? item as CommunicationSet: undefined}
                                    interval={props.type === 'intervals'  as CommitDataType ? item as Interval : undefined}
                                    interval_set={props.type === 'interval_sets'  as CommitDataType ? item as IntervalSet: undefined}
                                    interaction={props.type === 'interactions'  as CommitDataType ? item as Interaction : undefined}
                                    handleCheck={props.handleChange}
                                />
                            );
                        })}
                    </Stack>


                </Grid>
            </Grid>
        </Box>

    )
}

export default CommitSection;